import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./AddFormation.module.sass";
import { use100vh } from "react-div-100vh";
import { useNavigate } from "react-router-dom";
import TextInput from "../../components/TextInput";
import PhoneInput from "../../components/PhoneInput";
import Image from "../../components/Image";
import Dropdown from "../../components/Dropdown";
import MultiSelect from "../../components/Multiselect";
import { useAuth } from "../../contexts/AuthContext";
import { showSuccess, showError } from "../../services/toast.service";
import { pb } from "../../services/pocketbase";
import Switch from "../../components/Switch";
import { createFormation } from "../../services/formation.service";
import { createUser } from "../../services/user.service";
import { searchCenters } from "../../services/center.service";

const TYPE_DIPLOME_OPTIONS = [
  // Diplôme ou titre de niveau bac +5 et plus
  { value: '80', title: '80 : Doctorat' },
  { value: '73', title: '73 : Master' },
  { value: '75', title: '75 : Diplôme d\'ingénieur' },
  { value: '76', title: '76 : Diplôme d\'école de commerce' },
  { value: '79', title: '79 : Autre diplôme ou titre de niveau bac+5 ou plus' },
  // Diplôme ou titre de niveau bac +3 et 4
  { value: '62', title: '62 : Licence professionnelle' },
  { value: '63', title: '63 : Licence générale' },
  { value: '64', title: '64 : Bachelor universitaire de technologie BUT' },
  { value: '69', title: '69 : Autre diplôme ou titre de niveau bac +3 ou 4' },
  // Diplôme ou titre de niveau bac +2
  { value: '54', title: '54 : Brevet de Technicien Supérieur' },
  { value: '55', title: '55 : Diplôme Universitaire de technologie' },
  { value: '58', title: '58 : Autre diplôme ou titre de niveau bac+2' },
  // Diplôme ou titre de niveau bac
  { value: '41', title: '41 : Baccalauréat professionnel' },
  { value: '42', title: '42 : Baccalauréat général' },
  { value: '43', title: '43 : Baccalauréat technologique' },
  { value: '44', title: '44 : Diplôme de spécialisation professionnelle' },
  { value: '49', title: '49 : Autre diplôme ou titre de niveau bac' },
  // Diplôme ou titre de niveau CAP/BEP
  { value: '33', title: '33 : CAP' },
  { value: '34', title: '34 : BEP' },
  { value: '35', title: '35 : Certificat de spécialisation' },
  { value: '38', title: '38 : Autre diplôme ou titre de niveau CAP/BEP' },
  // Aucun diplôme ni titre
  { value: '25', title: '25 : Diplôme national du Brevet' },
  { value: '26', title: '26 : Certificat de formation générale' },
  { value: '13', title: '13 : Aucun diplôme ni titre professionnel' },
];

const TYPE_OF_DIPLOMA = [
  { value: 'Alternance', title: 'Alternance' },
  { value: 'Professionnalisation', title: 'Professionnalisation' },
  { value: 'Initial', title: 'Initial' },
];

const CompletAccountAddFormation = () => {
  const heightWindow = use100vh();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const [formation, setFormation] = useState({
    name: '',
    description: '',
    duration_months: '',
    degree_level: '',
    degree_title: '',
    alternance: false,
    is_active: true,
    rncp_code: '',
    diploma_code: '',
    type_diplome: '',
    qualification_title: '',
    course_duration: '',
    number_of_hoursinstudy: '',
    place_Identical_training: false,
    address: '',
    address_complement: '',
    city: '',
    department: '',
    zip_code: '',
    country: 'France',
    contract_types: ['Alternance'],
    cost_diplome: '',
    pedagogical_first_name: '',
    pedagogical_last_name: '',
    pedagogical_email: '',
  });
  const [isAlternance, setIsAlternance] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDegreeLevel, setSelectedDegreeLevel] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  // États pour la gestion du centre
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [isLocationSameAsCenter, setIsLocationSameAsCenter] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    if (!pb.authStore.isValid) {
      console.error('Utilisateur non connecté');
      navigate('/signin');
      return;
    }
  }, [navigate]);

  // useEffect pour la recherche de centres
  useEffect(() => {
    const fetchCenters = async () => {
      if (searchQuery.length >= 2) {
        try {
          const results = await searchCenters(searchQuery);
          setSearchResults(results);
          setShowResults(true);
        } catch (error) {
          console.error('Erreur lors de la recherche des centres:', error);
          setSearchResults([]);
          setShowResults(false);
        }
      } else {
        setSearchResults([]);
        setShowResults(false);
      }
    };

    fetchCenters();
  }, [searchQuery]);

  const handleFormationChange = (e) => {
    const { name, value } = e.target;
    console.log(`Champ modifié: ${name} = ${value}`);
    setFormation(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDropdownChange = (name, value) => {
    if (name === 'degree_level') {
      setSelectedDegreeLevel(value);
      setFormation(prev => ({
        ...prev,
        degree_level: value
      }));
    } else if (name === 'type_diplome') {
      setFormation(prev => ({
        ...prev,
        type_diplome: value
      }));
    }
  };

  const handleSwitchChange = (name, value) => {
    if (name === 'alternance') {
      setIsAlternance(value);
      setFormation(prev => ({
        ...prev,
        alternance: value
      }));
    } else if (name === 'place_Identical_training') {
      setFormation(prev => ({
        ...prev,
        place_Identical_training: value
      }));
    } else if (name === 'location_same_as_center') {
      setIsLocationSameAsCenter(value);
      // Si on active le switch et qu'un centre est sélectionné, copier ses données d'adresse
      if (value && selectedCenter) {
        setFormation(prev => ({
          ...prev,
          address: selectedCenter.address || '',
          address_complement: selectedCenter.address_complement || '',
          zip_code: selectedCenter.zip_code || '',
          city: selectedCenter.city || '',
          department: selectedCenter.department || '',
          country: selectedCenter.country || 'France',
          center_id: selectedCenter.id
        }));
      } else if (!value) {
        // Si on désactive le switch, vider les champs d'adresse
        setFormation(prev => ({
          ...prev,
          address: '',
          address_complement: '',
          zip_code: '',
          city: '',
          department: '',
          country: 'France'
        }));
      }
    }
  };

  // Handler pour la recherche de centres
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    if (selectedCenter && e.target.value !== selectedCenter.name) {
      setSelectedCenter(null);
    }
  };

  // Handler pour la sélection d'un centre
  const handleSelectCenter = (center) => {
    setSelectedCenter(center);
    setSearchQuery(center.name);
    setShowResults(false);

    // Si le switch "lieu identique" est activé, copier les données d'adresse
    if (isLocationSameAsCenter) {
      setFormation(prev => ({
        ...prev,
        address: center.address || '',
        address_complement: center.address_complement || '',
        zip_code: center.zip_code || '',
        city: center.city || '',
        department: center.department || '',
        country: center.country || 'France',
        center_id: center.id
      }));
    } else {
      // Sinon, juste associer le centre sans copier l'adresse
      setFormation(prev => ({
        ...prev,
        center_id: center.id
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      // Validation des champs obligatoires de la formation
      if (!formation.qualification_title || !formation.rncp_code || !formation.diploma_code || !formation.type_diplome || !formation.course_duration) {
        showError('Veuillez remplir tous les champs obligatoires de la formation');
        setIsSaving(false);
        return;
      }

      // Validation des champs obligatoires du membre pédagogique
      if (!formation.pedagogical_first_name || !formation.pedagogical_last_name || !formation.pedagogical_email) {
        showError('Veuillez remplir tous les champs obligatoires du membre pédagogique');
        setIsSaving(false);
        return;
      }

      // Validation du centre sélectionné
      if (!selectedCenter || !selectedCenter.id) {
        showError('Veuillez sélectionner un centre de formation');
        setIsSaving(false);
        return;
      }

      if (!pb.authStore.model.partner_id) {
        showError('Aucun partenaire associé à votre compte');
        setIsSaving(false);
        return;
      }

      const formationData = {
        name: formation.name,
        description: formation.description,
        duration_months: parseInt(formation.duration_months),
        degree_level: formation.degree_level,
        degree_title: formation.degree_title || '',
        alternance: isAlternance,
        is_active: true,
        rncp_code: formation.rncp_code || '',
        diploma_code: formation.diploma_code || '',
        type_diplome: formation.type_diplome || '',
        qualification_title: formation.qualification_title || '',
        course_duration: formation.course_duration ? parseInt(formation.course_duration) : null,
        number_of_hoursinstudy: formation.number_of_hoursinstudy ? parseInt(formation.number_of_hoursinstudy) : null,
        place_Identical_training: formation.place_Identical_training,
        address: formation.address || '',
        address_complement: formation.address_complement || '',
        city: formation.city || '',
        department: formation.department || '',
        zip_code: formation.zip_code || '',
        country: formation.country || 'France',
        contract_types: formation.contract_types,
        cost_diplome: formation.cost_diplome ? parseInt(formation.cost_diplome) : null,
        center_id: formation.center_id || selectedCenter?.id || null // Associer le centre sélectionné
      };

      // Créer la formation avec le service
      const createdFormation = await createFormation(formationData);
      console.log('Formation créée:', createdFormation);

      // Créer le membre pédagogique
      const memberData = {
        first_name: formation.pedagogical_first_name,
        last_name: formation.pedagogical_last_name,
        email: formation.pedagogical_email,
        phone: formation.pedagogical_phone || '',
        role: 'Pedagogical', 
        actif: true
      };

      try {
        await createUser(memberData);
        console.log('Membre pédagogique créé avec succès');
        showSuccess('Formation et membre pédagogique créés avec succès');
      } catch (memberError) {
        console.error('Erreur lors de la création du membre pédagogique:', memberError);
        // La formation a été créée mais pas le membre
        showError('Formation créée mais erreur lors de la création du membre pédagogique: ' + memberError.message);
      }

      // Mettre à jour l'état first_connexion de l'utilisateur
      try {
        await pb.collection('users').update(pb.authStore.model.id, {
          first_connexion: false
        });
      } catch (userUpdateError) {
        console.error('Erreur lors de la mise à jour des informations utilisateur:', userUpdateError);
      }

      // Finaliser l'onboarding - rediriger vers le dashboard admin
      navigate('/admin/dashboard');

    } catch (error) {
      console.error('Erreur lors de la création de la formation:', error);
      showError('Erreur lors de la création: ' + (error.message || 'Veuillez vérifier vos informations'));
    } finally {
      setIsSaving(false);
    }
  };

  const handleSkip = async () => {
    // Passer à l'étape suivante (création du centre)
    navigate('/partner/add-center');
  };

  const handlePrevious = () => {
    navigate('/partner/complete-account');
  };

  return (
    <div className={styles.row}>
      <div
        className={styles.col}
        style={{
          backgroundImage: `url('/images/content/loginbg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: heightWindow,
          flex: 1
        }}
      />
      <div className={styles.col} style={{ minHeight: heightWindow, flex: 1.5, overflow: 'auto', maxHeight: '100vh' }}>
        <div className={styles.head}>
          <div className={styles.logo}>
            <Image
              className={styles.pic}
              src="/images/logo.png"
              srcDark="/images/logo.png"
              alt="Core"
            />
          </div>
          <div className={cn("h2", styles.title)}>Créer votre première formation</div>
        </div>

        {/* This div will now handle the internal scrolling of the form content */}
        <div className={styles.container}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.body}>
              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Informations de la formation
                </h3>
                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Titre de qualification"
                    name="qualification_title"
                    type="text"
                    placeholder="Intitulé précis du diplôme ou titre visé"
                    value={formation?.qualification_title || ''}
                    onChange={handleFormationChange}
                    required
                    maxLength={255}
                  />
                  <TextInput
                    className={styles.field}
                    label="Code RNCP"
                    name="rncp_code"
                    type="text"
                    placeholder="Numéro RNCP du diplôme ou titre visé"
                    value={formation?.rncp_code || ''}
                    onChange={handleFormationChange}
                    required
                    maxLength={9}
                  />
                </div>
                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Code diplôme"
                    name="diploma_code"
                    type="text"
                    placeholder="Code du diplôme ou titre visé"
                    value={formation?.diploma_code || ''}
                    onChange={handleFormationChange}
                    required
                    maxLength={8}
                  />
                  <Dropdown
                    className={styles.field}
                    label="Type de diplôme"
                    name="type_diplome"
                    required
                    options={TYPE_DIPLOME_OPTIONS}
                    setValue={(option) => handleDropdownChange('type_diplome', option.value)}
                    value={TYPE_DIPLOME_OPTIONS.find(opt => opt.value === formation?.type_diplome)}
                  />
                </div>
                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Coût de la formation (€)"
                    name="cost_diplome"
                    type="number"
                    step="0.01"
                    placeholder="Montant en euros"
                    value={formation?.cost_diplome || ''}
                    onChange={handleFormationChange}
                  />
                  <MultiSelect
                    className={styles.field}
                    label="Type de contrat"
                    name="contract_types"
                    options={TYPE_OF_DIPLOMA}
                    setValue={(event) => {
                      const { name, value } = event.target;
                      handleFormationChange({
                        target: {
                          name,
                          value
                        }
                      });
                    }}
                    value={formation?.contract_types ?
                      formation.contract_types.map(type =>
                        TYPE_OF_DIPLOMA.find(opt => opt.value === type) || { value: type, title: type }
                      ) :
                      []
                    }
                  />
                </div>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Durée et volume horaire
                </h3>
                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Durée de formation (heures)"
                    name="course_duration"
                    type="number"
                    placeholder="Ex: 400"
                    value={formation?.course_duration || ''}
                    onChange={handleFormationChange}
                    required
                  />
                  <TextInput
                    className={styles.field}
                    label="Durée en distanciel (heures)"
                    name="number_of_hoursinstudy"
                    type="number"
                    placeholder="Ex: 100"
                    value={formation?.number_of_hoursinstudy || ''}
                    onChange={handleFormationChange}
                  />
                </div>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Membre pédagogique
                </h3>
                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Prénom"
                    name="pedagogical_first_name"
                    type="text"
                    placeholder="Ex: Jean"
                    value={formation?.pedagogical_first_name || ''}
                    onChange={handleFormationChange}
                    required
                  />
                  <TextInput
                    className={styles.field}
                    label="Nom"
                    name="pedagogical_last_name"
                    type="text"
                    placeholder="Ex: Dupont"
                    value={formation?.pedagogical_last_name || ''}
                    onChange={handleFormationChange}
                    required
                  />
                </div>

                <TextInput
                  className={styles.field}
                  label="Email"
                  name="pedagogical_email"
                  type="email"
                  placeholder="jean.dupont@exemple.com"
                  value={formation?.pedagogical_email || ''}
                  onChange={handleFormationChange}
                  required
                />

              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Centre de formation
                </h3>
                <div className={styles.searchContainer} style={{ position: 'relative' }}>
                  <TextInput
                    className={styles.field}
                    label="Rechercher un centre de formation"
                    name="center-search"
                    type="text"
                    placeholder="Nom du centre (min. 2 caractères)"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    required
                  />

                  {showResults && searchResults.length > 0 && (
                    <div className={styles.searchResults} style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                      zIndex: 1000,
                      maxHeight: '200px',
                      overflowY: 'auto'
                    }}>
                      {searchResults.map((center, index) => (
                        <div
                          key={center.id || index}
                          className={styles.resultItem}
                          onClick={() => handleSelectCenter(center)}
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                        >
                          <img
                            src={center.logoUrl || "/images/content/school_logo.png"}
                            alt={center.name}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '4px',
                              objectFit: 'cover'
                            }}
                          />
                          <div>
                            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{center.name}</div>
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              {center.address}
                              {center.zip_code && center.city && `, ${center.zip_code} ${center.city}`}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {showResults && searchResults.length === 0 && searchQuery.length >= 2 && (
                    <div className={styles.noResults} style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      padding: '12px',
                      textAlign: 'center',
                      color: '#666'
                    }}>
                      Aucun centre de formation trouvé
                    </div>
                  )}
                </div>

                {selectedCenter && (
                  <div className={styles.selectedCenter} style={{
                    marginTop: '20px',
                    padding: '16px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                  }}>
                    <h4 style={{ margin: '0 0 12px 0', fontSize: '16px' }}>Centre sélectionné</h4>
                    <div style={{ display: 'grid', gap: '8px' }}>
                      <div><strong>Nom:</strong> {selectedCenter.name}</div>
                      <div><strong>Adresse:</strong> {selectedCenter.address}
                        {selectedCenter.address_complement && `, ${selectedCenter.address_complement}`}
                        {selectedCenter.zip_code && selectedCenter.city && `, ${selectedCenter.zip_code} ${selectedCenter.city}`}
                      </div>
                      {selectedCenter.phone && <div><strong>Téléphone:</strong> {selectedCenter.phone}</div>}
                      {selectedCenter.email && <div><strong>Email:</strong> {selectedCenter.email}</div>}
                    </div>
                  </div>
                )}
                <div className={styles.line} style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                      <div className={styles.title} style={{ flex: 1 }}>
                        Lieu de formation identique à l'adresse du centre ?
                      </div>
                      <Switch
                        className={styles.switch}
                        value={isLocationSameAsCenter}
                        onChange={(value) => handleSwitchChange('location_same_as_center', value)}
                      />
                    </div>
              </div>

              {selectedCenter && !isLocationSameAsCenter && (
                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>
                    Lieu de formation
                  </h3>
                  <TextInput
                    className={styles.field}
                    label="Adresse"
                    name="address"
                    type="text"
                    placeholder="123 rue de la Formation"
                    value={formation.address}
                    onChange={handleFormationChange}
                  />
                  <TextInput
                    className={styles.field}
                    label="Complément d'adresse"
                    name="address_complement"
                    type="text"
                    placeholder="Bâtiment A, 2ème étage"
                    value={formation.address_complement}
                    onChange={handleFormationChange}
                  />
                  <div className={styles.formGrid}>
                    <TextInput
                      className={styles.field}
                      label="Code postal"
                      name="zip_code"
                      type="text"
                      placeholder="75001"
                      value={formation.zip_code}
                      onChange={handleFormationChange}
                    />
                    <TextInput
                      className={styles.field}
                      label="Ville"
                      name="city"
                      type="text"
                      placeholder="Paris"
                      value={formation.city}
                      onChange={handleFormationChange}
                    />
                  </div>
                  <div className={styles.formGrid}>
                    <TextInput
                      className={styles.field}
                      label="Département"
                      name="department"
                      type="text"
                      placeholder="75"
                      value={formation.department}
                      onChange={handleFormationChange}
                    />
                    <TextInput
                      className={styles.field}
                      label="Pays"
                      name="country"
                      type="text"
                      placeholder="France"
                      value={formation.country}
                      onChange={handleFormationChange}
                    />
                  </div>
                </div>
              )}



              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '40px', paddingBottom: '20px', width: '100%' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    type="button"
                    className={cn("button-stroke", styles.buttonStroke)}
                    onClick={handlePrevious}
                  >
                    Précédent
                  </button>
                  <button
                    type="button"
                    className={cn("button-stroke", styles.buttonStroke)}
                    onClick={handleSkip}
                  >
                    Ignorer cette étape
                  </button>
                </div>
                <div>
                  <button
                    className={cn("button", styles.button)}
                    type="submit"
                    disabled={isSaving}
                  >
                    {isSaving ? "Sauvegarde en cours..." : "Terminer"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompletAccountAddFormation;